import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-scamper',
  	templateUrl: './toolcards-scamper.component.html',
  	styleUrls: ['./toolcards-scamper.component.scss']
})
export class ToolcardsScamperComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
